<template>
  <div>
    {{"350624" | getTreeLabelByCodeFilter("area", "~~~~")}}
     {{"350624,350200,123" | getTreeLabelByCodesFilter("area", "~~~~", "")}}
    {{"诏安县" | getTreeCodeByLabelFilter("area", "~~~~")}}
    {{"诏安县,思明区,哈哈" | getTreeCodeByLabelsFilter("area", "~~~~")}}
    
    <el-cascader-dict  v-model="areaCode" collapse-tags dictType="area" maxLevel="2" clearable :props="areaOptionProps" @dictChange="handleChange"></el-cascader-dict>
  
  </div>
</template>

<script>
import {getTreeLabelByCode, getTreeCodeByLabel, getTreeLabelByCodes, getTreeCodeByLabels} from "~/index"
export default {
  name: "el-cascader-dict-normal",
  data() {
    return {
      areaCode: "",
      areaOptionProps: {
        value: "id",
        label: "areaName",
        checkStrictly: false,
        multiple: true
      }
    }
  },
  created() {
    getTreeLabelByCode("350624", "area").then(data => {
      console.log("🚀 ~ file: el-cascader-dict-normal.vue ~ line 26 ~ getTreeCodeByLabel ~ data", data)
    })

    getTreeCodeByLabel("诏安县", "area").then(data => {
      console.log("🚀 ~ file: el-cascader-dict-normal.vue ~ line 26 ~ getTreeCodeByLabel ~ data", data)
    })

    getTreeLabelByCodes("350624,150600,350600", "area").then(data => {
      console.log("🚀 ~ file: el-cascader-dict-normal.vue ~ line 36 ~ getTreeLabelByCodes ~ data", data)
    })
    getTreeCodeByLabels("诏安县,思明区,丰泽区", "area").then(data => {
      console.log("🚀 ~ file: el-cascader-dict-normal.vue ~ line 36 ~ getTreeLabelByCodes ~ data", data)
    })
  },
  methods: {
    handleChange(val) {
      console.log(val)
    }
  }
}
</script>

<style>

</style>